import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { selectTrainingName } from "../../app/slices/TrainingSlice";
import { UpdateTrainingName } from "../../hooks/UpdateTrainingNameHook";
import useBufferedTextCommit from "../../hooks/useBufferedTextCommit";
import "./TrainingActionbarTitle.css";

export default function TrainingActionbarTitle() {
  const trainingName = useSelector(selectTrainingName);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [updateTrainingName] = UpdateTrainingName();
  const { currentValue, handleValueChange, flushPendingValue } =
    useBufferedTextCommit({
      value: trainingName,
      onCommit: updateTrainingName,
      debounceMs: 500,
    });

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === "NumpadEnter") {
      inputRef.current?.blur();
    }
  };

  return (
    <div className="trainingactionbartitle-root">
      <SchoolOutlinedIcon
        className="trainingactionbartitle-icon"
        sx={{ fontSize: 22 }}
      />
      <input
        className="trainingactionbartitle-input"
        ref={inputRef}
        value={currentValue}
        onBlur={flushPendingValue}
        onChange={(e) => handleValueChange(e.target.value)}
        onKeyDown={onKeyDown}
      />
    </div>
  );
}
